module.exports = __webpack_public_path__ + "static/media/Innenspannelemente_preview_6274676196.1e48052e.jpg";